import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a50fe7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-lock-alt" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-lock-alt" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "py-m"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Odeslat ")

import {
	NInput,
	NButton,
	NSpace,
	NResult,
	NAlert,
	NForm,
	NFormItem,
	NInputGroup,
	NInputGroupLabel,
	FormRules,
	FormValidationError,
} from 'naive-ui';
import { reactive, ref } from 'vue';
import { API } from '@/api';
import { useRoute } from 'vue-router';

interface Errors {
	password?: string;
	password_check?: string;
	message?: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { params } = useRoute();
const request_id = ref<string | undefined>(
	typeof params.request_id === 'string' ? params.request_id : undefined,
);
const pending = ref<boolean>(false);
const rPasswordFormItemRef = ref();
const formRef = ref();
const successMessage = ref<string | undefined>();
const errors = reactive<Errors>({
	password: undefined,
	password_check: undefined,
	message: undefined,
});
const formModel = ref({
	password: null,
	password_check: null,
});

const handlePasswordInput = () => {
	if (formModel.value.password_check) {
		rPasswordFormItemRef.value.validate({ trigger: 'password-input' });
	}
};
const rules = ref<FormRules>({
	password: [
		{
			required: true,
			message: 'Heslo je povinné',
			trigger: ['input', 'blur'],
		},
		{
			validator: (rule, value) => {
				const letterUpper = /[A-Z]/;
				const letterLower = /[a-z]/;
				const number = /[0-9]/;

				return (
					number.test(value) &&
					letterUpper.test(value) &&
					letterLower.test(value) &&
					value.length >= 8
				);
			},
			message: 'Heslo musí mít minimálně 8 znaků a musí obsahovat malé, velké písmeno a číslo',
			trigger: ['input', 'blur'],
		},
	],
	password_check: [
		{
			required: true,
			message: 'Heslo pro kontrolu je povinné',
			trigger: ['input', 'blur'],
		},
		{
			validator: (rule, value) => {
				const letterUpper = /[A-Z]/;
				const letterLower = /[a-z]/;
				const number = /[0-9]/;

				return (
					number.test(value) &&
					letterUpper.test(value) &&
					letterLower.test(value) &&
					value.length >= 8
				);
			},
			message: 'Heslo musí mít minimálně 8 znaků a musí obsahovat malé, velké písmeno a číslo',
			trigger: ['input', 'blur'],
		},
		{
			validator: (rule, value) => {
				return value === formModel.value.password;
			},
			message: 'Hesla se neshodují',
			trigger: ['blur', 'password-input'],
		},
	],
});
const submitForm = async () => {
	if (typeof request_id.value === 'undefined') {
		return;
	}
	successMessage.value = undefined;
	errors.password_check = undefined;
	errors.password = undefined;
	errors.message = undefined;
	if (formRef.value !== null && typeof formRef.value.validate === 'function') {
		await formRef.value.validate(async (validationErrors: FormValidationError) => {
			if (!validationErrors) {
				pending.value = true;
				try {
					await API.auth.createNewPassword({
						password: formModel.value.password,
						password_check: formModel.value.password_check,
						request_id: request_id.value || '',
					});
					successMessage.value = 'Nové heslo bylo úspěšně vytvořeno';
					pending.value = false;
				} catch (error) {
					pending.value = false;
					const catchError: AjaxResponseDto = error as AjaxResponseDto;
					const { message, fields } = catchError?.payload as MessageResponseDto;

					if (typeof fields === 'object' && fields !== null && Object.keys(fields).length > 0) {
						Object.keys(fields).forEach((key) => {
							if (key === 'password_check' || key === 'password') {
								errors[key] = fields[key];
							}
						});
					} else {
						errors.message = message || 'Neznámá chyba nového hesla';
					}
				}
			}
		});
	}
};

return (_ctx: any,_cache: any) => {
  return (successMessage.value)
    ? (_openBlock(), _createBlock(_unref(NResult), {
        key: 0,
        status: "success",
        class: "pt-m",
        description: typeof successMessage.value === 'string' ? successMessage.value : ''
      }, null, 8, ["description"]))
    : (_openBlock(), _createBlock(_unref(NForm), {
        key: 1,
        ref_key: "formRef",
        ref: formRef,
        model: formModel.value,
        rules: rules.value,
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            path: "password",
            feedback: _unref(errors).password,
            "validation-status": _unref(errors).password ? 'error' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NInput), {
                    value: formModel.value.password,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.password) = $event)),
                    size: "large",
                    "show-password-on": "click",
                    type: "password",
                    placeholder: "Heslo",
                    disabled: pending.value,
                    onInput: handlePasswordInput
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          _createVNode(_unref(NFormItem), {
            ref_key: "rPasswordFormItemRef",
            ref: rPasswordFormItemRef,
            path: "password_check",
            feedback: _unref(errors).password_check,
            "validation-status": _unref(errors).password_check ? 'error' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NInput), {
                    value: formModel.value.password_check,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.password_check) = $event)),
                    size: "large",
                    "show-password-on": "click",
                    type: "password",
                    placeholder: "Heslo pro kontrolu",
                    disabled: pending.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          (_unref(errors).message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(NAlert), { type: "error" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(errors).message), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(NSpace), {
            justify: "center",
            class: "py-m"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NButton), {
                type: "primary",
                size: "large",
                "attr-type": "submit",
                disabled: 
					!!(
						pending.value ||
						formModel.value.password_check === null ||
						formModel.value.password_check === '' ||
						formModel.value.password === null ||
						formModel.value.password === '' ||
						formModel.value.password_check !== formModel.value.password
					)
				,
                loading: pending.value
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"]))
}
}

})